import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/index'
import VCharts from 'v-charts'
import echarts from 'echarts'
import ElementUI from 'element-ui'
import x2js from 'x2js' //xml数据处理插件
import '@/assets/theme/element-variables.scss'
import '@/permission'

// import './assets/theme/index.css'
// import './assets/theme/app.css'

Vue.prototype.$echarts = echarts
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(Storage, {
	namespace: 'pro__',
	name: 'ls',
	storage: 'local',
})

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
